import axios from 'axios';
import {
    DC_FORM_SENDER_APPLICATIONS_RESTORE_DRAFT,
    DC_FORM_SENDER_APPLICATIONS_DRAFTS_CHECK,
} from '@alfa-bank/site-dc-env-config';

import type {
    IDraftsCheckResponse,
    TDraftsCheckApiArgs,
    IDraftRestoreResponse,
} from '../models/api';

export const draftsCheckApi = ({ appId, businessUid }: TDraftsCheckApiArgs) => {
    return axios.get<IDraftsCheckResponse>(DC_FORM_SENDER_APPLICATIONS_DRAFTS_CHECK({ appId }), {
        headers: {
            BusinessUid: businessUid,
        },
    });
};

export const draftRestoreApi = (draftId: string) => {
    return axios.get<IDraftRestoreResponse>(DC_FORM_SENDER_APPLICATIONS_RESTORE_DRAFT({ draftId }));
};
